import { Classes as BlueprintClasses } from "@blueprintjs/core";
import { css } from "styled-components";

import type { TextStyleBlock } from "@superblocksteam/shared";

import { CLASS_NAMES } from "../classnames";
import type { GeneratedTheme } from "../types";
import {
  activeStyles,
  checkboxStyleFromStyleBlock,
  disabledStyles,
  errorStyles,
  inputStyleFromStyleBlock,
  radioStyleFromStyleBlock,
  styleFromDimension,
  styleFromTextBlockWithColors,
  switchStyleFromStyleBlock,
} from "./utils";

export const generateInputStyles = (
  inputStyles: GeneratedTheme["inputs"],
  placeholderStyle: TextStyleBlock,
) => {
  const val = css`
    .${CLASS_NAMES.CHECKBOX} {
      ${checkboxStyleFromStyleBlock(inputStyles.checkbox)}
    }

    .${CLASS_NAMES.SWITCH} {
      ${switchStyleFromStyleBlock(inputStyles.switch)}
    }

    .${CLASS_NAMES.RADIO} {
      ${radioStyleFromStyleBlock(inputStyles.radio)}
    }

    textarea.${CLASS_NAMES.INPUT}, input.${CLASS_NAMES.INPUT} {
      ${inputStyleFromStyleBlock(inputStyles.input)}
    }

    // Table widget: Override Blueprint's border radius for search input with stronger CSS precedence
    .${CLASS_NAMES.INPUT} > .${BlueprintClasses.INPUT}[type="search"] {
      border-radius: ${styleFromDimension(inputStyles.input.borderRadius)};
    }

    .ant-form-item-has-error input.${CLASS_NAMES.INPUT} {
      ${errorStyles(inputStyles.input)}
    }

    .${CLASS_NAMES.INPUT} {
      input,
      textarea {
        ${inputStyleFromStyleBlock(inputStyles.input)}
      }
      &.${CLASS_NAMES.DISABLED_MODIFIER} {
        input,
        textarea {
          opacity: 0.6;
          ${disabledStyles(inputStyles.input)}
        }
      }
      &.${CLASS_NAMES.ERROR_MODIFIER}:not(.${CLASS_NAMES.DISABLED_MODIFIER}) {
        input,
        textarea {
          ${errorStyles(inputStyles.input)}
        }
      }

      .${BlueprintClasses.INPUT_ACTION} {
        button {
          ${styleFromTextBlockWithColors(placeholderStyle)}
        }
      }
    }
    .${CLASS_NAMES.TAG_INPUT} {
      .${BlueprintClasses.INPUT_GHOST} {
        &::placeholder {
          ${styleFromTextBlockWithColors(placeholderStyle)}
        }
      }
      .${BlueprintClasses.INPUT} {
        ${inputStyleFromStyleBlock(inputStyles.input)}
        padding: 0px 3px;
        &.${BlueprintClasses.ACTIVE} {
          ${activeStyles(inputStyles.input)}
        }
      }
      &.${CLASS_NAMES.ERROR_MODIFIER}:not(.${CLASS_NAMES.DISABLED_MODIFIER}) {
        .${BlueprintClasses.INPUT} {
          ${errorStyles(inputStyles.input)}
        }
      }
      &.${CLASS_NAMES.DISABLED_MODIFIER} {
        .${BlueprintClasses.INPUT} {
          ${disabledStyles(inputStyles.input)}
        }
      }
      &.${BlueprintClasses.ACTIVE} {
        .${BlueprintClasses.INPUT} {
          ${activeStyles(inputStyles.input)}
        }
      }
    }

    .${CLASS_NAMES.INPUT} {
      .tox-tinymce {
        ${inputStyleFromStyleBlock(inputStyles.input)}
      }
      &.${CLASS_NAMES.ERROR_MODIFIER}:not(.${CLASS_NAMES.DISABLED_MODIFIER}) {
        .tox-tinymce {
          ${errorStyles(inputStyles.input)}
        }
      }
    }
  `;
  return val.join("");
};
